import React from "react";
import "./Navbar.scss";
import { images } from "../../constants";
import { HiMenuAlt4 } from "react-icons/hi";
import { FaRegSun, FaSun, FaMoon } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { useState } from "react";
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";
import "react-lazy-load-image-component/src/effects/blur.css";
import SlideMenu from "../SlideMenu";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const { darkMode, setDarkMode } = useContext(ThemeContext);

  const changeMode = () => {
    if (darkMode === false) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  };

  return (
    <nav
      className={
        darkMode === true
          ? toggle === false
            ? "app__navbar-true"
            : "app__navbar-toggle"
          : toggle === false
          ? "app__navbar"
          : "app__navbar-toggle"
      }
    >
      <div className="app__navbar-logo">
        {darkMode === true ? (
          <LazyLoadImage
            src={images.darkLogo}
            alt="logo"
            className="app__navbar-logoImg"
            effect="blur"
          />
        ) : (
          <img
            src={images.lightLogo}
            alt="logo"
            className="app__navbar-logoImg"
          />
        )}
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "work", "skills", "contact"].map((item) => (
          <li
            className={`app__flex p-text ${
              darkMode === true ? "app__navbar-link-true" : "app__navbar-link"
            }`}
            key={`link-${item}`}
          >
            <div />
            <a
              href={`#${item}`}
              className={
                darkMode === true ? "nav__links-darkMode" : "nav__links"
              }
            >
              {item}
            </a>
          </li>
        ))}
      </ul>

      <div>
        <FaMoon
          className={
            darkMode === true ? "app__modeChange-true" : "app__modeChange"
          }
          onClick={changeMode}
        />
      </div>

      <div
        className={
          darkMode === true ? "app__navbar-menu-true" : "app__navbar-menu"
        }
      >
        <HiMenuAlt4 onClick={() => setToggle(true)} />

        {toggle && <SlideMenu setToggle={setToggle} />}
      </div>
    </nav>
  );
};

export default Navbar;
